import React from "react";
import styles from "./MobileSignIn.module.scss";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useState } from "react";
import { toast } from "react-toastify";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import facebook from "../../../assets/images/Facebook.png";
import google from "../../../assets/images/google1.png";
import { useGoogleLogin } from "@react-oauth/google";
import { addAccount } from "../../../redux/slices/accountSlice";
import axios from "../../../components/Hooks/axios";
import { setAuth, setUserObject } from "../../../redux/slices/authSlice";
import FacebookLogin from "@greatsumini/react-facebook-login";
import { validateEmail, validateSignInPassword, validateSignIn } from "../../../utils/authValidation";
import logo from "../../../assets/images/mainlogo1.png";

const MobileSignIn = () => {
	const navigate = useNavigate();
	const dispatch = useDispatch();

	const [email, setEmail] = useState("");
	const [password, setPassword] = useState("");
	const [errors, setErrors] = useState({});
	const [touched, setTouched] = useState({});
	const [btnDisabled, setBtnDisabled] = useState(false);
	const [rememberMe, setRememberMe] = useState(false);
	const [passIcon1, setPassIcon1] = useState(false);

	const handleBlur = (field) => {
		setTouched((prev) => ({ ...prev, [field]: true }));
		if (field === "email") {
			setErrors((prev) => ({ ...prev, email: validateEmail(email) }));
		} else if (field === "password") {
			setErrors((prev) => ({ ...prev, password: validateSignInPassword(password) }));
		}
	};

	const handleEmailChange = (e) => {
		const val = e.target.value;
		setEmail(val);
		if (touched.email || errors.email) {
			setErrors((prev) => ({ ...prev, email: validateEmail(val) }));
		}
	};

	const handlePasswordChange = (e) => {
		const val = e.target.value;
		setPassword(val);
		if (touched.password || errors.password) {
			setErrors((prev) => ({ ...prev, password: validateSignInPassword(val) }));
		}
	};

	const handelSignIn = (e) => {
		if (e && e.preventDefault) e.preventDefault();

		setTouched({ email: true, password: true });
		const cleanEmail = email.trim();
		const { isValid, errors: validationErrors } = validateSignIn({ email: cleanEmail, password });

		if (!isValid) {
			setErrors(validationErrors);
			const firstError = Object.values(validationErrors)[0];
			if (firstError) toast.warn(firstError);
			return;
		}

		setErrors({});
		setBtnDisabled(true);

		const data = JSON.stringify({
			email: cleanEmail,
			password: password,
		});

		axios
			.post("/auth/login", data, {
				headers: {
					"Content-Type": "application/json",
				},
			})
			.then(({ data }) => {
				dispatch(setAuth({ userId: data.data._id, token: data.token, rememberMe }));
				dispatch(setUserObject(data.data));
				axios.defaults.headers.Authorization = data.token;
				setBtnDisabled(false);
				dispatch(addAccount({ userId: data.data._id, user: data.data, token: data.token }));
				navigate("/Home", { replace: true });
			})
			.catch(({ response }) => {
				const errMsg = response?.data?.message || response?.data?.error || "Sign in failed";
				toast.error(errMsg);
				setBtnDisabled(false);
			});
	};

	const forgetPasswordHandler = () => {
		navigate("/forget-password");
	};

	const login = useGoogleLogin({
		onSuccess: (tokenResponse) => {
			axios
				.get(`https://www.googleapis.com/oauth2/v3/userinfo?access_token=${tokenResponse.access_token}`)
				.then(({ data }) => {
					axios
						.post("/auth/googleRegister", { ...data, isLoginOnly: true })
						.then(({ data }) => {
							if (data.status) {
								dispatch(setAuth({ userId: data.data._id, token: data.token }));
								dispatch(setUserObject(data.data));
								axios.defaults.headers.Authorization = data.token;
								setBtnDisabled(false);
								dispatch(addAccount({ userId: data.data._id, user: data.data, token: data.token }));
								const hasInterests = data.data?.interestName && data.data.interestName.length > 0;
								const destination = (data.isNewUser || !hasInterests) ? "/interest" : "/Home";
								navigate(destination, { replace: true });
							}
						})
						.catch((e) => {
							toast.error(e.response?.data?.message || "Google Login Failed");
							console.log(e);
						});
				})
				.catch((e) => console.log(e));
		},
		onError: (tokenResponse) => console.log(tokenResponse),
	});

	const responseFacebook = (response) => {
		if (!response.accessToken) {
			toast.error("Facebook Login was cancelled or failed.");
			return;
		}

		axios
			.post("/auth/facebookRegister", { accessToken: response.accessToken, isLoginOnly: true })
			.then(({ data }) => {
				if (data.status) {
					dispatch(setAuth({ userId: data.data._id, token: data.token }));
					dispatch(setUserObject(data.data));
					axios.defaults.headers.Authorization = data.token;
					setBtnDisabled(false);
					dispatch(addAccount({ userId: data.data._id, user: data.data, token: data.token }));
					navigate(data.isNewUser ? "/interest" : "/Home", { replace: true });
				}
			})
			.catch((e) => {
				toast.error(e.response?.data?.message || "Facebook Login Failed");
			});
	};

	return (
		<div className={styles.mainContainer}>
			<div className={styles.singinLogo}>
				<img src={logo} alt="logoImg" className={styles.Logo} />
			</div>
			<form className={styles.form} onSubmit={handelSignIn} noValidate>
				<div className={styles.buttons}>
					<button
						type="button"
						className={styles.signInButton}
						onClick={() => {
							navigate("/signup");
						}}>
						Sign Up
					</button>
					<button type="button" className={`${styles.signInButton} ${styles.activeButton}`}>Sign In</button>
				</div>

				<div className={styles.inputContainer}>
					<div className={styles.input}>
						<label className={styles.label}>E-mail</label>
						<input
							type="email"
							className={`${styles.inputBox} ${touched.email && errors.email ? styles.inputError : ""}`}
							value={email}
							placeholder="Enter Your Email"
							onChange={handleEmailChange}
							onBlur={() => handleBlur("email")}
						/>
						{touched.email && errors.email && (
							<span className={styles.errorMessage}>{errors.email}</span>
						)}
					</div>

					<div className={styles.passwordWrapper}>
						<div className={styles.input}>
							<label className={styles.label}>Password</label>

							<div className={`${styles.inputPass} ${touched.password && errors.password ? styles.inputError : ""}`}>
								<input
									type={passIcon1 ? "text" : "password"}
									placeholder="Enter Your Password"
									value={password}
									onChange={handlePasswordChange}
									onBlur={() => handleBlur("password")}
								/>
								<span onClick={() => setPassIcon1(!passIcon1)}>
									{passIcon1 ? <FaEye size={"2.5rem"} /> : <FaEyeSlash size={"2.5rem"} />}
								</span>
							</div>
							{touched.password && errors.password && (
								<span className={styles.errorMessage}>{errors.password}</span>
							)}
						</div>
					</div>

					<div className={styles.forgetRemember}>
						<section className={styles.remember}>
							<input
								type="checkbox"
								className={styles.radioButton}
								checked={rememberMe}
								onChange={(e) => setRememberMe(e.target.checked)}
								id="Remember_me"
							/>
							<label htmlFor="Remember_me" className={styles.rememberMe}>
								Remember me
							</label>
						</section>
						<p className={styles.link} onClick={forgetPasswordHandler}>
							Forget Password
						</p>
					</div>

					<div className={styles.submitButtonContainer}>
						<button
							type="submit"
							className={`${styles.signInButton} ${styles.activeButton} ${styles.submitButton}`}
							disabled={btnDisabled}>
							Sign In
						</button>
					</div>
				</div>

				<div className={styles.design}>
					<p className={styles.continue}>Continue With</p>
				</div>

				<div className={styles.footer}>
					<button type="button" onClick={() => login()} title="Continue with Google">
						<img src={google} alt="Google" className={styles.google} />
					</button>
					<FacebookLogin
						appId={`${process.env.REACT_APP_FACEBOOK_APP_ID}`}
						autoLoad={false}
						scope="email"
						fields="name,email,picture"
						callback={responseFacebook}
						render={(renderProps) => (
							<button type="button" onClick={renderProps.onClick} title="Continue with Facebook">
								<img src={facebook} alt="Facebook" className={styles.facebook} />
							</button>
						)}
					/>
				</div>
			</form>
		</div>
	);
};

export default MobileSignIn;

